import React, {useState} from "react"
import {Btn, FormInput, Modal} from "./";
import {useCore} from "../hooks";
import {updateBill, OrderItemType} from "../utils";
import {OrderItem, Voucher} from "depoto-core";

export const ModalSale: React.FC = () => {
  const { currentOrder, setCurrentOrder, vats } = useCore()
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [saleType, setSaleType] = useState<'percent' | 'amount'>('percent')
  const [percent, setPercent] = useState<number>(0)
  const [amount, setAmount] = useState<number>(0)
  const defaultVat = () => vats?.find(v => v.default)

  const openModal = () => {
    setIsVisible(true)
  }

  const closeModal = () => {
    setIsVisible(false)
  }

  const addSale = () => {
    const nextOrder = {...currentOrder}
    // todo
    // amount: orderItem with price = amount, calc without vat.. etc
    // percent: add percent coefficient to each oItem.sale .. let the util fn calc final prices. or just show it in the operation row..
    // OK. but .. todo: dont do percent type now - save to reducer and calc it again every time order changes.. (for newly added items etc.)
    const nextPercentageSales = currentOrder.percentageSales?.length ? [...currentOrder.percentageSales] : []
    if (saleType === 'percent') {
      // nextOrder.items.forEach(oi => oi.sale = percent)
      // updateBill({ currentOrder: nextOrder, setCurrentOrder })
      nextPercentageSales.push(new Voucher({
        name: `Sleva: ${percent}%`,
        discountType: 'percentage',
        discountPercent: percent
      }))
      nextOrder.percentageSales = nextPercentageSales
      updateBill({ currentOrder: nextOrder, setCurrentOrder })
    } else if (saleType === 'amount') {
      const vat = defaultVat()
      const orderItem = new OrderItem({
        type: OrderItemType.sale,
        name: 'Sleva',
        price: amount * -1,
        priceWithoutVat: amount * -1 * vat.coefficient,
        quantity: 1,
        vat,
      })
      updateBill({ currentOrder: nextOrder, setCurrentOrder, orderItem })
    }
    closeModal()
  }

  return (
    <Modal
      modalOpenBtn={<Btn className="btn-link font-bold" children={'Sleva'} icon={'fa-percent'} onClick={openModal} />}
      isVisible={isVisible}
      modalTitle={'Sleva'}
      modalWidth={'sm'}
      onClose={closeModal}
      content={
        <div>
          <div className="flex flex-row justify-evenly rounded-md overflow-hidden mb-3">
            <Btn className={`flex-1 ${saleType === 'percent' ? 'btn-primary' : 'btn-primary btn-soft'}`} icon={'fa-badge-percent'} children={'Procento'} onClick={() => setSaleType('percent')} />
            <Btn className={`flex-1 ${saleType === 'amount' ? 'btn-primary' : 'btn-primary btn-soft'}`} icon={'fa-badge-dollar'} children={'Částka'} onClick={() => setSaleType('amount')} />
          </div>
          <div>
            {saleType === 'percent' ? (
              <FormInput label={'Procento'} value={`${percent}`} onChange={e => setPercent(Number(e))} />
            ) : (
              <FormInput label={'Částka'} value={`${amount}`} onChange={e => setAmount(Number(e))} />
            )}
          </div>
        </div>
      }
      footerContent={
        <div className="flex flex-row justify-between items-center">
          <Btn className="btn-base-100" icon={'fa-ban'} children={'Zrušit'} onClick={() => setIsVisible(false)}/>
          <Btn className="btn-primary" icon={'fa-check'} children={'Přidat slevu'} onClick={addSale}/>
        </div>
      }
    />
  )
}
